import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/(tours)/layout.tsx")